import { render, staticRenderFns } from "./ShopifyKategori.vue?vue&type=template&id=69ad5c1c&scoped=true"
import script from "./ShopifyKategori.vue?vue&type=script&lang=js"
export * from "./ShopifyKategori.vue?vue&type=script&lang=js"
import style0 from "./ShopifyKategori.vue?vue&type=style&index=0&id=69ad5c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad5c1c",
  null
  
)

export default component.exports